import { render } from "./classicMusic.vue?vue&type=template&id=ae17d570"
import script from "./classicMusic.vue?vue&type=script&lang=js"
export * from "./classicMusic.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\david\\Desktop\\Netloud\\whiteLabel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__